import React from 'react';
import styled from 'styled-components';
import { Form } from 'connex-cds';
import { AddedItemsMobile } from './AddedItems/AddedItemsMobile';
import { MaterialSummaryDesktop } from './MaterialSummary/MaterialSummaryDesktop';
import BatchResults from './BatchResults/BatchResults';
import DeliveryInformation from './DeliveryInformation/DeliveryInformation';
import { mobileStyle } from './Style';

const StyledMobile = styled.div`
  ${mobileStyle}
`;

export const DotWorkflowMobile = ({ data, ticket, order, filtereData }) => {
  const { values } = Form.useFormContext();

  return (
    <StyledMobile>
      <AddedItemsMobile productCompliance={values?.productCompliance ?? {}} />
      <MaterialSummaryDesktop source={filtereData?.consumption} results={data?.testsResult} />
      <BatchResults source={filtereData?.batch} results={data?.testsResult} />
      <DeliveryInformation ticket={ticket ?? {}} order={order ?? {}} />
    </StyledMobile>
  );
};
